import React from "react";
import { Box, Typography, Tooltip, useMediaQuery, useTheme } from "@mui/material";

export default function AttendanceStats({ dailyStats, overallPercentage }) {
  const theme = useTheme();
  const stackVertically = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box
      sx={{
        mt: 2,
        display: "flex",
        flexDirection: stackVertically ? "column" : "row",
        justifyContent: "space-between",
        alignItems: stackVertically ? "stretch" : "center",
        gap: stackVertically ? 2 : 0,
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: 0.5,
          flexWrap: "wrap",
          justifyContent: stackVertically ? "flex-start" : "center",
          overflowX: stackVertically ? "auto" : "visible",
          pb: stackVertically ? 0.5 : 0,
          maxWidth: "100%",
        }}
      >
        {dailyStats.map((day) => (
          <Tooltip
            key={day.date}
            title={`${day.date}: ${day.present}/${day.total} (${day.percentage}%)`}
          >
            <Box
              sx={{
                width: 8,
                height: stackVertically ? 24 : 30,
                flexShrink: 0,
                bgcolor: "success.main",
                opacity: Math.max(0.08, day.percentage / 100),
                borderRadius: 1,
              }}
            />
          </Tooltip>
        ))}
      </Box>
      <Typography variant="body2" fontWeight={500}>
        Monthly attendance: {overallPercentage}%
      </Typography>
    </Box>
  );
}
